let HTTP_URL = process.env.VUE_APP_ENV == 'test' ? 'http://47.97.243.140:8081' : 'https://api.thecover.cn';
let ACTIVITY_URL = process.env.VUE_APP_ENV == 'test' ? 'http://170.240.110.234:7001' : 'https://actapi.thepage.cn';

export default {
    //安卓下载apk地址
    DOWNLOAD_ADDRESS: 'https://api.thecover.cn/download.js',
    //scheme地址
    APP_SCHEME_URL: 'cover://cn.thecover.www',
    //微信里面scheme地址
    WEIXIN_APP_SCHEME_URL: 'http://0.0.0.0:22021',
    //UniversalLink地址
    UNIVERSALLINK: 'https://wapcdn.thecover.cn/UniversalLinks/index.html',
    //封面新闻接口地址
    HTTP_URL,
    //活动接口地址 
    ACTIVITY_URL,
    // 七牛图片服务器地址
    QINIUDOMAIN: 'http://7xte9b.com2.z0.glb.qiniucdn.com/',
    //微信应用宝地址
    WEXIN_APP_DOWNLOAD_ADDRESS: "http://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia",
    ApiToken: sessionStorage.getItem('TOKEN'),
    Api_sign_root: '12345678',
    wx_appid: 'wx1294924fd43f1119',
    //当前时间戳
    timestamp: new Date().getTime(),
    framework: [
        {
            name: '加强思想理论建设<br>繁荣哲学社会科学',
            child: ['深挖中华民族传统文化', '加强对中国传统节日内涵研究', '党建理论创新', '社会主义文化强国建设', '加强红色文化教育', '繁荣发展哲学社会科学', '中国特色社会主义理论当代化研究'],
        },
        {
            name: '提升公民道德素养',
            child: ['有效开展核心价值观学习与实践', '提升新时代文明实践中心建设水平', '精神文明创建', '志愿服务', '核心价值观网络化教育'],
        },
        {
            name: '健全志愿服务体系',
            child: ['研究挖掘', '形式创新', '加强保护', '普及教育', '市场转化'],
        },
        {
            name: '改善文化民生',
            child: ['增加基层文化服务总量建设', '公共文化网络升级', '创新服务机制', '公共文化基础设施建设', '公共文化空间的营造', '公共文化服务网络数字化', '农村文化建设', '高校文化建设'],
        },
        {
            name: '推进媒体深度融合',
            child: ['优化产业结构', '培育龙头企业', '创新消费模式', '文化产业数字化', '健全文化产业服务体系', '重大文化赛事引进'],
        },
        {
            name: '提升文艺作品质量',
            child: ['推动文艺作品精品化和IP化', '提升网络文艺品质', '完善文艺作品评价机制', '经典作品现代演绎', '推动经典出圈出海', '加强文艺人才队伍建设'],
        },
        {
            name: '传承弘扬中华<br>优秀传统文化',
            child: ['天府旅游名县建设', '巴蜀文化旅游走廊建设', '建设世界旅游目的地', '智慧文旅建设', '文体旅商融合发展', '文创引领形成本地文旅IP'],
        },
        {
            name: '推动文化产业<br>高质量发展',
            child: ['天府旅游名县建设', '巴蜀文化旅游走廊建设', '建设世界旅游目的地', '智慧文旅建设', '文体旅商融合发展', '文创引领形成本地文旅IP'],
        },
        {
            name: '加强对外文化交流',
            child: ['天府旅游名县建设', '巴蜀文化旅游走廊建设', '建设世界旅游目的地', '智慧文旅建设', '文体旅商融合发展', '文创引领形成本地文旅IP'],
        },
        {
            name: '深化文化体制改革',
            child: ['天府旅游名县建设', '巴蜀文化旅游走廊建设', '建设世界旅游目的地', '智慧文旅建设', '文体旅商融合发展', '文创引领形成本地文旅IP'],
        },
        {
            name: '推进文化旅游<br>融合发展',
            child: ['天府旅游名县建设', '巴蜀文化旅游走廊建设', '建设世界旅游目的地', '智慧文旅建设', '文体旅商融合发展', '文创引领形成本地文旅IP'],
        },
        {
            name: '其他精彩建言',
            child: ['天府旅游名县建设', '巴蜀文化旅游走廊建设', '建设世界旅游目的地', '智慧文旅建设', '文体旅商融合发展', '文创引领形成本地文旅IP'],
        },
    ],
}
